import React from "react";
import { TEMPLATES } from "../../constants/templates";
import { DocuBuilder } from "../../components";
import { getPurchaseOrderDetails } from "./helper";
import ShipmentOrderDetails from "./ShipmentOrderDetails";

const ShipmentBuilderContent = ({
  id,
  data,
  isLoading,
  disabled,
  locationId = 1,
}) => {
  const packingSlip = getPurchaseOrderDetails(data);
  const Template = TEMPLATES?.find(
    ({ id }) => id === packingSlip?.templateId,
  )?.Template;

  return (
    <DocuBuilder
      id={id}
      name={data?.name}
      data={data}
      title="Shipment"
      label="Shipment Order"
      disabled={disabled}
      isLoading={isLoading}
      Template={Template}
      isPreview={false}
      FormComponent={
        <ShipmentOrderDetails disabled={disabled} locationId={locationId} />
      }
    />
  );
};

export default ShipmentBuilderContent;
